export default __webpack_public_path__ + "static/media/sh_quote.e2da9407.svg";